<script>

import FInput from "../inputs/FInput.vue";
import FCheckbox from "../inputs/FCheckbox.vue";
import FNested from "../inputs/FNested.vue";
import _ from "lodash";

export default {
  name: "LiveGridFilter",
  components: {FNested, FCheckbox, FInput},
  emits: ['filters'],
  props: {
    filterValues: {
      type: Object,
      required: true,
    },
    selectedValues: {
      type: Object,
      default: []
    },
  },
  data() {
    return {
      sendFilter: null,
      filters: {},
      loaded: false,
    }
  },
  mounted() {
    this.filters = _.clone(this.filterValues);
    this.loaded = true;
  },
  methods: {
    updateFilter() {
      this.$emit('filters', this.filters)
    },
    filterCycle() {
      clearTimeout(this.sendFilter);
      this.sendFilter = setTimeout(this.updateFilter, 750);
    },
    updateSearchValue(value) {
      this.filters.search = value;
      if (value.length > 2) {
        this.filterCycle();
      }
    },
    updateSaleValue(checkbox) {
      this.filters.sale = checkbox;
      this.filterCycle();
    },
    updateStockValue(checkbox) {
      this.filters.stock = checkbox;
      this.filterCycle();
    },
    updateCategoriesValue(slug) {
      this.filters.categories = this.filters.categories.map(category => {
        category.checked = category.slug === slug ? !category.checked : category.checked;
        return category;
      });
      this.filterCycle();
    },
    updateCountriesValue(slug) {
      this.filters.countries = this.filters.countries.map(country => {
        country.checked = country.slug === slug ? !country.checked : country.checked;
        return country;
      });
      this.filterCycle();
    },
    updateDiametersValue(value) {
      this.filters.diameters = this.filters.diameters.map(diameter => {
        diameter.checked = diameter.value === value ? !diameter.checked : diameter.checked;
        return diameter;
      });
      this.filterCycle();
    },
    toggleOption(list, value) {
      this.filters[list] = this.filters[list].map(item => {
        item.checked = item.value === value ? !item.checked : item.checked;
        return item;
      });
      this.filterCycle();
    }
  },
  computed: {
    madeInGeorgia() {
      if (this.filters.countries && this.filters.countries.length) {
        return this.filters.countries.find(country => country.slug === 'georgia').checked;
      }
      return false;
    }
  }
}
</script>

<template>
  <section class="mb-3">
    <div class="lead mb-3 fw-bold">{{ $t('filters.search') }}</div>
    <f-input :options="{label:'', value: selectedValues.q, placeholder:$t('filters.product.name')}"
             @update-value="updateSearchValue($event)"/>
  </section>

  <section class="mb-3">
    <div class="lead mb-3 fw-bold" v-if="filters.categories && filters.categories.length ">
      კატეგორიები
    </div>

    <div class="cat-list">
      <template v-for="category in filters.categories">
        <template v-if="category.products > 0">
          <a :href="category.url" v-if="category.items < 1" class="cat-item"
             :class="{'is-checked': category.checked}"
             @click.prevent="updateCategoriesValue(category.slug)">
            <span class="cat-name">{{ category.name }}</span>
            <span class="cat-count">{{ category.products }}</span>
          </a>
          <a :href="category.url" v-else class="cat-item">
            <span class="cat-name">{{ category.name }}</span>
            <span class="cat-count">{{ category.products }}</span>
          </a>
        </template>
      </template>
    </div>
  </section>


  <div class="mb-3 filter-check">
    <f-checkbox :options="{label:$t('filters.sale'), checked: selectedValues.sale}" @update-checkbox="updateSaleValue($event)"/>
  </div>
  <div class="mb-3 filter-check">
    <f-checkbox :options="{label:$t('filters.available')}" @update-checkbox="updateStockValue($event)"/>
  </div>
<!--  <div class="mb-3">-->
<!--    <f-checkbox :options="{label:'დამზადებულია საქართველოში', checked: madeInGeorgia}"-->
<!--                @update-checkbox="updateCountriesValue('georgia')"/>-->
<!--  </div>-->
  <section class="mb-3" v-if="filters.brands && filters.brands.length">
    <div class="lead mb-3 fw-bold">ბრენდი</div>
    <div class="cat-list">
      <a href="#" v-for="item in filters.brands" :key="item.value" class="cat-item"
         :class="{'is-checked': item.checked}" @click.prevent="toggleOption('brands', item.value)">
        <span class="cat-name">{{ item.name }}</span>
        <span class="cat-count">{{ item.products }}</span>
      </a>
    </div>
  </section>

  <section class="mb-3" v-if="filters.powers && filters.powers.length">
    <div class="lead mb-3 fw-bold">სიმძლავრე</div>
    <div class="cat-list">
      <a href="#" v-for="item in filters.powers" :key="item.value" class="cat-item"
         :class="{'is-checked': item.checked}" @click.prevent="toggleOption('powers', item.value)">
        <span class="cat-name">{{ item.name }}</span>
        <span class="cat-count">{{ item.products }}</span>
      </a>
    </div>
  </section>

  <section class="mb-3" v-if="filters.openings && filters.openings.length">
    <div class="lead mb-3 fw-bold">გაღება</div>
    <div class="cat-list">
      <a href="#" v-for="item in filters.openings" :key="item.value" class="cat-item"
         :class="{'is-checked': item.checked}" @click.prevent="toggleOption('openings', item.value)">
        <span class="cat-name">{{ item.name }}</span>
        <span class="cat-count">{{ item.products }}</span>
      </a>
    </div>
  </section>

  <section class="mb-3" v-if="filters.sizes && filters.sizes.length">
    <div class="lead mb-3 fw-bold">ზომა</div>
    <div class="cat-list">
      <a href="#" v-for="item in filters.sizes" :key="item.value" class="cat-item"
         :class="{'is-checked': item.checked}" @click.prevent="toggleOption('sizes', item.value)">
        <span class="cat-name">{{ item.name }}</span>
        <span class="cat-count">{{ item.products }}</span>
      </a>
    </div>
  </section>

  <section class="mb-3" v-if="filters.diameters && filters.diameters.length">
    <div class="lead mb-3 fw-bold">დიამეტრი</div>
    <div class="cat-list">
      <a href="#" v-for="diameter in filters.diameters" :key="diameter.value" class="cat-item"
         :class="{'is-checked': diameter.checked}"
         @click.prevent="updateDiametersValue(diameter.value)">
        <span class="cat-name">{{ diameter.name }}</span>
        <span class="cat-count">{{ diameter.products }}</span>
      </a>
    </div>
  </section>



<!--  <section class="mb-3">-->
<!--    <div class="lead mb-3 fw-bold" v-if="filters.countries && filters.countries.length ">-->
<!--      ქვეყნები-->
<!--    </div>-->

<!--    <div class="list-group">-->
<!--      <template v-for="country in filters.countries">-->
<!--        <a :href="country.url" v-if="country.items < 1" class="list-group-item text-primary"-->
<!--           @click.prevent="updateCountriesValue(country.slug)">-->
<!--          {{ country.name }} ({{ country.products }})-->
<!--          <i class="bi float-end" :class="{'bi-check' : country.checked}"></i>-->
<!--        </a>-->
<!--      </template>-->
<!--    </div>-->
<!--  </section>-->

</template>

<style scoped>
.filter-check {
  font-size: 16px;
  font-weight: 600;
  padding: .55rem 0;
}

.filter-check :deep(input[type=checkbox]) {
  accent-color: #71239b;
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.cat-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: -.75rem;
  margin-right: -.75rem;
}

.cat-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: .55rem .75rem;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #222;
  text-decoration: none;
  transition: background-color .15s ease-in-out, color .15s ease-in-out;
}

.cat-item:hover {
  background: #EBF2EA;
  color: var(--bs-primary);
}

.cat-item.is-checked {
  background: #EBF2EA;
  color: var(--bs-primary);
  font-weight: 600;
}

.cat-count {
  flex-shrink: 0;
  min-width: 26px;
  padding: 1px 8px;
  border-radius: 10px;
  background: #f1f1f1;
  color: #666;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

.cat-item:hover .cat-count,
.cat-item.is-checked .cat-count {
  background: #fff;
  color: var(--bs-primary);
}
</style>
